import { Auth } from '@aws-amplify/auth';
import { CognitoUserSession } from 'amazon-cognito-identity-js';

import AuthStorage from 'utils/cognito/storage';
import { StorageKeys } from 'utils/local-storage';

import { withNetworkRetries } from './util';

let pendingCurrentSessionCall: Promise<CognitoUserSession> | null = null;

export const getCurrentSessionWrapper = () => {
  // de-dupe calls to cognito as it does not dedupe internally for errors
  if (pendingCurrentSessionCall) {
    return pendingCurrentSessionCall;
  }

  const result = withNetworkRetries(() => Auth.currentSession(), 'Auth.currentSession').finally(
    () => {
      pendingCurrentSessionCall = null;
    }
  );

  pendingCurrentSessionCall = result;

  return result;
};

// return the current user session
export const getCurrentSession = (): Promise<CognitoUserSession | null> =>
  getCurrentSessionWrapper().catch(() => {
    // if cognito failed to get a valid session
    // clear local storage to prevent a user with
    // no session from being "logged in" in app state
    // @ts-expect-error TS(2345) FIXME: Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
    AuthStorage.setItem(StorageKeys.USER_AUTH_TOKEN, null);
    return null;
  });
